import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { num: 1, title: 'Customer calls your current number', desc: 'Nothing changes for your caller. They dial the same number they always have.' },
  { num: 2, title: 'Your team rings as normal', desc: 'Your staff gets first priority. If someone picks up, the call proceeds normally.' },
  { num: 3, title: 'No answer after 15–25 seconds', desc: 'The call forwards conditionally to your Valtivo AI line. No busy signal. No voicemail.' },
  { num: 4, title: 'AI handles intake, routing, and handoff', desc: "Valtivo captures the caller's details, qualifies the inquiry, and routes a structured summary to your team." },
];

const HowItWorks = () => (
  <section id="how-it-works" className="py-20 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>How It Works</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#f1f1f1' }}>
          Your team answers first.<br />AI catches what they miss.
        </h2>
        <p className="text-base" style={{ color: '#666' }}>Think of it as replacing voicemail, not replacing your office.</p>
      </motion.div>
      <div className="grid md:grid-cols-4 gap-6">
        {steps.map((step, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="p-6 rounded-2xl border relative" style={{ background: '#111', borderColor: '#1f1f1f' }}>
            <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mb-4"
              style={{ background: '#1a3a2a', color: '#4ade80' }}>
              {step.num}
            </div>
            <h3 className="text-sm font-semibold mb-2 leading-snug" style={{ color: '#f1f1f1' }}>{step.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: '#666' }}>{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;